import TagManager from 'react-gtm-module';


export enum GACategory {
    PARKING_SESSIONS = 'PARKING_SESSIONS',
    VEHICLES = 'VEHICLES',
    SUPPORT = 'SUPPORT',
    SETTINGS = 'SETTINGS',
    REGISTRATION = 'REGISTRATION',
    ONBOARDING = 'ONBOARDING'
}

export enum GAAction {
    // PARKING_SESSIONS 
    'PARKING_SESSIONS_EXPORT' = 'parking_sessions_exported',
    // VEHICLES
    'VALIDATE_LICENSE_PLATES' = 'validate_license_plates',
    'IMPORT_LICENSE_PLATES' = 'import_license_plates',
    // SUPPORT 
    'STAR_RATING' = 'star_rating',
    // REGISTRATION 
    'REGISTRATION_SINGLE_STEP_COMPLETED' = 'registration_single_step_completed', // 3 steps
    'REGISTRATION_ACCOUNT_CREATION_COMPLETED' = 'registration_account_creation_completed',
}

export function trackDataLayerEvent(dataLayer: Record<string, unknown>) {
    try {
        TagManager.dataLayer({ dataLayer });
    } catch (error) {
        console.warn('Failed to send analytics event', error);
    }
}

//===================================================================================
// COOKIE CONSENT
//===================================================================================

type ConsentState = 'granted' | 'denied';

// Consent Mode commands must be pushed as an `arguments` object (like gtag does), not a plain object
function gtag(..._args: unknown[]) {
    // eslint-disable-next-line prefer-rest-params
    TagManager.dataLayer({ dataLayer: arguments });
}

// Must run before GTM is initialized
export function setDefaultGtmConsent() {
    // TagManager.dataLayer() only pushes `arguments` as-is when window.dataLayer exists;
    // otherwise it JSON-serializes it into a plain object, which Consent Mode ignores
    const win = window as unknown as { dataLayer?: unknown[] };
    win.dataLayer = win.dataLayer || [];

    gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        functionality_storage: 'granted',
        security_storage: 'granted',
        wait_for_update: 500,
    });
}

export function updateGtmConsent({ analytics, marketing }: { analytics: boolean, marketing: boolean }) {
    const toState = (accepted: boolean): ConsentState => accepted ? 'granted' : 'denied';
    gtag('consent', 'update', {
        analytics_storage: toState(analytics),
        ad_storage: toState(marketing),
        ad_user_data: toState(marketing),
        ad_personalization: toState(marketing),
    });
}
